// scroll bar
import 'simplebar/src/simplebar.css';
import './fonts/ngayogyan/ngayogyan-indo.ttf';
import './fonts/bookos-regular.ttf';
import './fonts/bookos-bold.ttf';
import './fonts/bookos-italic.ttf';
import './fonts/bookos-bold-italic.ttf';
import './index.css';

import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

//
import { ReactKeycloakProvider } from '@react-keycloak/web';
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import keycloak from './keycloack';

// ----------------------------------------------------------------------

ReactDOM.render(
  <HelmetProvider>
    <BrowserRouter>
      <ReactKeycloakProvider authClient={keycloak}>
        <App />
      </ReactKeycloakProvider>
    </BrowserRouter>
  </HelmetProvider>,
  document.getElementById('root')
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
